import { useEffect, useState } from "react";
import { Box, Button, Grid2 as Grid, IconButton, Modal, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { editInversionClient } from "../../actions/users";
import FilePreviewer from "../common/FilePreview";

import { useDispatch } from "react-redux";

const DetailInvestmentModal = ({ cancelCallback, item, visible }) => {
  const dispatch = useDispatch();
  const [titulo, setTitulo] = useState("Tu trámite está en proceso.");
  const [btn, setBtn] = useState("Cancelar inversión");
  const [selectedFileIndex, setSelectedFileIndex] = useState(0);

  useEffect(() => {
    setSelectedFileIndex(0); // Reset index when item changes
    if (item?.type === "Servicio") {
      setBtn("Cancelar servicio");
    } else {
      setBtn("Cancelar inversión");
    }
  }, [item]);

  useEffect(() => {
    if (item?.status.toString() === "1") {
      setTitulo("Tu trámite ha sido aprobado.");
    } else if (item?.status.toString() === "2") {
      setTitulo("Tu trámite ha sido cancelado.");
    } else {
      setTitulo("Tu trámite está en proceso.");
    }
  }, [item]);

  const cancelar = async () => {
    await dispatch(editInversionClient({ status: 2 }, item.idUsr, item.reference));
    return cancelCallback();
  }

  const currentFile = item?.file && Array.isArray(item.file)
    ? item.file[selectedFileIndex]
    : item?.file;

  return (
    <Modal
      open={visible}
      className="modal-content"
      onClose={() => {
        cancelCallback();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="modal-general modal-large">
        <IconButton
          sx={{
            position: 'relative',
            top: -35,
            left: "97%",
            color: 'grey.600',
            '&:hover': {
              backgroundColor: 'grey.100',
            },
          }}
          onClick={() => {
            cancelCallback();
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
        <Typography className="titleMain" variant="h6" component="h6">
          Visualizar comprobante de pago
        </Typography>
        <Typography className="subtitleMain">
          Visualiza tu comprobante de operación
        </Typography>
        <Grid container spacing={3} mt={5}>
          <Grid
            size={{ md: 6, lg: 8 }}
            sx={{ maxHeight: '65vh', overflowY: 'auto' }}
          >
            {item?.file && Array.isArray(item.file) && item.file.length > 1 && (
              <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {item.file.map((_, index) => (
                  <Button
                    key={index}
                    variant={selectedFileIndex === index ? "contained" : "outlined"}
                    size="small"
                    onClick={() => setSelectedFileIndex(index)}
                  >
                    Archivo {index + 1}
                  </Button>
                ))}
              </Box>
            )}
            <FilePreviewer
              file={currentFile}
            />
          </Grid>
          <Grid className="description" size={{ md: 6, lg: 4 }}>
            <Typography className="titleMain" variant="h6" component="h6">
              {titulo}
            </Typography>
            <Typography className="text-modal" mt={1}>
              Recuerda que tu comprobante debe cumplir con:
            </Typography>
            <ol className="list-items">
              <li>Corresponder al trámite actual.</li>
              <li>Reflejar el monto de inversión correcto.</li>
              <li>Incluir una fecha reciente y válida.</li>
              <li>Contener toda la información de pago necesaria.</li>
              <li>Ser legible en su totalidad.</li>
            </ol>
            <Grid size={12} mt={3}>
              {
                item?.status.toString() === "0" && (
                  <Button
                    onClick={cancelar}
                    variant="contained"
                    color="error"
                    sx={{ color: 'white' }}
                    fullWidth
                  >
                    {btn}
                  </Button>
                )
              }
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}

export default DetailInvestmentModal;
